// extracted by mini-css-extract-plugin
export default {"icon":"history-download-button_icon__phrGo","disabled":"history-download-button_disabled__iDxKD","placeHolderShimmer":"history-download-button_placeHolderShimmer__SCzLX"};